import moment from 'moment'
import React from 'react'
import { Link } from 'react-router-dom'

function Footor() {
    return (
        <footer className='main-footer'>
            <div className='footer-left'>
                <span>
                    © {moment().format('YYYY')} ProTrade Plus Inc. All rights
                    reserved
                </span>
            </div>
            <div className='footer-right'>
                <Link to='/privacy-policy' target='_blank'>
                    Terms of Use
                </Link>
                <Link
                    to='/privacy-policy'
                    target='_blank'
                    className='privacy-text'
                >
                    {' '}
                    Privacy Policy
                </Link>
            </div>
        </footer>
    )
}

export default Footor
